module.exports = __webpack_public_path__ + "img/34-oldster.ebc35996.svg";